export default __webpack_public_path__ + "static/media/inbound_sales_ai.0d91bbcb.png";